export const routes = {
  home: {
    index: "/home",
  },
  tokenDetail: {
    index: "/tokenDetail",
  },
};
